import React from 'react';
import PropTypes from 'prop-types';
import { widgets } from 'react-trello';
import Typography from '@material-ui/core/Typography';
import CustomLaneMenu from './customLaneMenu';

const CustomDeliveryGroupLaneHeader = ({
  updateTitle, canAddLanes, editLaneTitle, label, title, t, ...props
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Typography variant='body1' color='textPrimary' style={{ fontWeight: 'bold' }}>
          {editLaneTitle ?
            <widgets.InlineInput value={title} border placeholder={t('placeholder.title')} resize='vertical' onSave={updateTitle} /> :
            title
          }
        </Typography>
        <Typography variant='body2' color='textPrimary'>
          {label}
        </Typography>
      </div>
      {canAddLanes && <CustomLaneMenu {...props} />}
    </div>
  );
};


CustomDeliveryGroupLaneHeader.propTypes = {
  updateTitle: PropTypes.func,
  editLaneTitle: PropTypes.bool,
  canAddLanes: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func.isRequired,
};

CustomDeliveryGroupLaneHeader.defaultProps = {
  updateTitle: () => {},
  editLaneTitle: false,
  canAddLanes: false,
};

export default CustomDeliveryGroupLaneHeader;
